export enum TypeECSEnum {
  CHAUDIERES_GAZ = 'CHAUDIERES_GAZ',
  CHAUDIERES_FIOUL = 'CHAUDIERES_FIOUL',
  CHAUDIERES_BOIS = 'CHAUDIERES_BOIS',
  RESEAU_CHALEUR = 'RESEAU_CHALEUR',
  CHAUFFE_EAU_GAZ = 'CHAUFFE_EAU_GAZ',
  CHAUFFE_EAU_ELEC = 'CHAUFFE_EAU_ELEC',
  POMPE_CHALEUR_CHAUDIERE_GAZ = 'POMPE_CHALEUR_CHAUDIERE_GAZ',
  BALLON_SOLAIRE_COL = 'BALLON_SOLAIRE_COL',

  CHAUDIERE_GAZ = 'CHAUDIERE_GAZ',
  BALLON_EFFET_JOULE = 'BALLON_EFFET_JOULE',
  CHAUFFE_EAU_THERMO_ELEC = 'CHAUFFE_EAU_THERMO_ELEC',
  CHAUFFE_EAU_THERMO_GAZ = 'CHAUFFE_EAU_THERMO_GAZ',
  POMPE_CHALEUR_GAZ = 'POMPE_CHALEUR_GAZ',
  BALLON_SOLAIRE_IND_ELEC = 'BALLON_SOLAIRE_IND_ELEC',
  BALLON_SOLAIRE_IND_GAZ = 'BALLON_SOLAIRE_IND_GAZ',
}
